/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const BankDisabled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22.5 21.385L23 21.3859V22.8859H1V21.3859L20.438 21.385L18.937 19.884L3 19.8859V18.3859H5.25V9.88586H3V8.38586L7.437 8.384L5.856 6.803L5.732 6.885L3 6.88586L4.774 5.721L1.46967 2.41619L2.53033 1.35553L22.5303 21.3555L22.5 21.385ZM10.75 11.697V18.3859H13.25V14.197L10.75 11.697ZM14.75 15.697V18.3859H17.25V18.197L14.75 15.697ZM8.938 9.885L6.75 9.88586V18.3859H9.25V10.197L8.938 9.885ZM21 8.38586V9.88586H18.75V15.575L17.25 14.075V9.88586H14.75V11.575L11.559 8.385L21 8.38586ZM12 1L12.3991 1.25088L21 6.88586L18.267 6.885L12 2.77086L8.344 5.17L7.265 4.091L11.6009 1.25088L12 1ZM12 4.88586C12.5523 4.88586 13 5.33357 13 5.88586C13 6.43814 12.5523 6.88586 12 6.88586C11.4477 6.88586 11 6.43814 11 5.88586C11 5.33357 11.4477 4.88586 12 4.88586Z"
                        fill={color}
                    />
                </svg>
        );
    };
